// React hook over the data.js per-app config singleton. Pages and routes
// read `useBatteryAppConfig()` and get the live `{ enabled, features }`
// shape. The Layout component (which is always mounted on the authed
// routes) subscribes to /stores/{storeId} and pushes the doc into
// applyStoreCycleOverrides — that's what feeds this hook.

import { useSyncExternalStore } from "react";
import { subscribeBatteryAppConfig, batteryAppConfig } from "./data.js";

export function useBatteryAppConfig() {
  return useSyncExternalStore(
    (cb) => subscribeBatteryAppConfig(cb),
    () => batteryAppConfig(),
    () => batteryAppConfig(),
  );
}

// Convenience — returns true if a named feature is currently enabled. Use
// from pages that just need to know whether to render a control:
//   if (useFeatureEnabled("tvMode")) { ... }
export function useFeatureEnabled(featureName) {
  const cfg = useBatteryAppConfig();
  return cfg.enabled && cfg.features?.[featureName] !== false;
}
